import { Pipe, PipeTransform } from '@angular/core'
import { OptionConfig, OptionGroupConfig } from '@app-domains/ui/components/select/select.component.types'

@Pipe({
    name: 'isSelectOption',
    standalone: false,
})
export class IsSelectOptionPipe implements PipeTransform {

    transform(value: OptionConfig | OptionGroupConfig): value is OptionConfig {
        return ! (value as any).options
    }

}
